<mat-toolbar class="toolbar">
  <!-- Izquierda: hamburguesa -->
  <div class="toolbar-left">
    <button mat-icon-button class="menu-btn" (click)="onMenuToggle()" aria-label="Toggle sidebar">
      <mat-icon>menu</mat-icon>
    </button>
  </div>

  <!-- Centro: búsqueda -->
  <!-- <div class="search-box">
    <mat-icon class="search-icon">search</mat-icon>
    <input placeholder="Search..." aria-label="Search" />
  </div> -->

  <span class="spacer"></span>

  <!-- Derecha: acciones -->
  <div class="toolbar-right">
    <!-- Toggle tema -->
    <button
      mat-icon-button
      class="action-btn"
      (click)="toggleTheme()"
      [attr.aria-label]="theme.darkMode() ? 'Switch to light mode' : 'Switch to dark mode'"
    >
      <mat-icon>{{ theme.darkMode() ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>

    <!-- Notificaciones -->
    <!-- <button mat-icon-button class="action-btn" aria-label="Notifications">
      <mat-icon [matBadge]="'5'" matBadgeColor="warn" matBadgeSize="small"> notifications </mat-icon>
    </button> -->

    <!-- Avatar + usuario -->
    <div class="user-chip" [matMenuTriggerFor]="userMenu">
      <div class="avatar">{{ user.firstName?.charAt(0) }}{{ user.lastName?.charAt(0) }}</div>
      <span class="user-name">{{ user.firstName + ' ' + user.lastName }}</span>
      <mat-icon class="chevron">expand_more</mat-icon>
    </div>

    <mat-menu #userMenu="matMenu" xPosition="before">
      <button mat-menu-item>
        <a mat-menu-item [href]="urlAccount">
          <mat-icon>person</mat-icon>
          <span>Mi Perfil</span>
        </a>
      </button>
      <mat-divider />
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Salir</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
